import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import { array, string } from 'prop-types';
import styled from 'styled-components';
import { useViewport } from '../../../context/viewport.context';
import { bpWidth, colors, sizes } from '../../../styles/variables';
import GridCarousel from './GridCarousel.jsx';
import SwipeCarousel from './SwipeCarousel.jsx';

const LargeCarouselCol = styled(Col)`
  .slick-list {
    width: 100%;
    padding-top: 0 !important;
  }

  .slick-slide {
    height: 700px;

    img {
      height: 700px;
    }

    video {
      height: 700px;
    }
  }

  .slick-slide.slick-active.slick-center.slick-current {
    margin-right: 0;
  }

  button.slick-arrow::before {
    display: none !important;
  }

  button.slick-arrow {
    width: 50%;
    height: 100%;
    z-index: 1;

    &.slick-next {
      right: 0;
    }

    &.slick-prev {
      left: 0;
    }
  }

  .slick-dots li button:before {
    color: ${colors.gray100};
    font-size: 7px;
    opacity: 1;
  }

  .slick-dots li.slick-active button:before {
    color: ${colors.gray400};
    font-size: 7px;
    opacity: 1;
  }

  @media (${bpWidth.desktopSm}) {
    .slick-slide {
      height: 500px;

      img {
        height: 500px;
      }

      video {
        height: 500px;
      }
    }
  }

  @media (${bpWidth.tablet}) {
    .slick-list {
      padding-left: 0 !important;
    }

    .slick-slide.slick-active.slick-current {
      margin-left: 0;
      margin-right: 1rem;
    }

    .slick-slide {
      height: 450px;

      img {
        width: 87.5vw;
        height: 450px;
      }

      video {
        width: 87.5vw;
        height: 450px;
        object-fit: cover;
      }
    }

    .slick-dots.slick-thumb {
      bottom: -35px;
      display: flex;
      flex-shrink: 0;
    }
  }

  @media (${bpWidth.mobile}) {
    .slick-slide {
      height: 350px;

      img {
        width: 88vw;
        height: 350px;
      }

      video {
        width: 88vw;
        height: 350px;
      }
    }
  }
`;

const ProductVariantCarousels = (props) => {
  const { topCarousels } = props;
  const { viewWidth } = useViewport();

  // Pure prop-derived, no effect needed — re-derives on every render (e.g. on color-variant
  // change) same as the effect it replaces, but also renders correctly on the very first
  // (SSR/SSG) render instead of staying empty until after hydration.
  const variantSlides = topCarousels || [];

  // Render exactly one carousel, computed synchronously from viewWidth (already correct on the
  // client's first render — see viewport.context.js) rather than mounting both unconditionally:
  // each carousel independently triggers its own eager image/video downloads regardless of CSS
  // visibility (display:none does not stop loading="eager" from firing), so mounting both
  // doubled real network cost and delayed the actual LCP image. This accepts a one-time
  // hydration-correction flash for viewports where the SSR default (viewWidth=1280,
  // desktop-sized) doesn't match the real client — the same tradeoff already used elsewhere in
  // this codebase, justified here by the measured network cost of the alternative.
  const carousel =
    viewWidth > sizes.containerMaxWidth.tablet ? (
      <GridCarousel variantSlides={variantSlides} />
    ) : (
      <SwipeCarousel variantSlides={variantSlides} />
    );

  return (
    <Row>
      <LargeCarouselCol id="largeCarousel" xs={8} sm={8} md={9} lg={11}>
        {carousel}
      </LargeCarouselCol>
    </Row>
  );
};

ProductVariantCarousels.propTypes = {
  activeVariant: string,
  topCarousels: array,
};
ProductVariantCarousels.defaultProps = {
  topCarousels: [],
};

export default ProductVariantCarousels;
